module.exports = __webpack_public_path__ + "img/4_142.531e7fe3.png";